import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Paper, Grid, IconButton, Card } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { generateClient } from "aws-amplify/api";
import { listSeries } from "../../graphql/queries";
import { deleteSeries } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomDataGrid from "../../components/CustomDataGrid";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dataGridContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  dataGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "100%",
  },
}));

const Series = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = generateClient();
  const [series, setSeriesList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSeriesList();
  }, []);

  const fetchSeriesList = async () => {
    try {
      setLoading(true);
      const response = await client.graphql({
        query: listSeries,
      });
      const seriesList = response.data.listSeries.items;
      setSeriesList(seriesList);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "title", headerName: "Title", flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
    { field: "plot", headerName: "Plot", flex: 1 },
    { field: "releaseDate", headerName: "Release date", flex: 1 },

    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={() => deleteSeasonById(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  const deleteSeasonById = async (seriesId) => {
    try {
      await client.graphql({
        query: deleteSeries,
        variables: { input: { id: seriesId } },
      });

      fetchSeriesList();
    } catch (err) {
      console.log("Error deleting Season:", err);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={() => navigate("/create/series")}
          sx={{
            width: { xs: "100%", md: "200px" },
            backgroundColor: "#000d1a",
            color: "white",
            fontWeight: "bold",
            borderRadius: "8px",
          }}
        >
          Create Series
        </Button>
      </Grid>
      <Card sx={{ marginTop: 2 }}>
        <Grid item xs={12}>
          <div className={classes.dataGridContainer}>
            <CustomDataGrid
              rows={series}
              columns={columns}
              pageSize={10}
              loading={loading}
            />
          </div>
        </Grid>
      </Card>
    </>
  );
};

export default Series;
